/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive } from "@fortawesome/free-solid-svg-icons";

const ArchiveIcon = () => <FontAwesomeIcon icon={faArchive} />;

export default ArchiveIcon;
